import styled, { css } from 'styled-components';
import { themeColor } from '@whitelabel/helpers/style/colors';
import { StyledAccountSecondaryNavBar as SharedStyledAccountSecondaryNavBar } from '@whitelabel/rentalcover-shared/styled/StyledSecondaryNavBar';
import NavItem from '../../../../components/NavItem';

export const StyledAccountSecondaryNavBar = styled(SharedStyledAccountSecondaryNavBar)`
  padding-block: 0;

  a {
    min-height: 3rem;
  }
`;

export const StyledNavItem = styled(NavItem)<{ $active?: boolean }>`
  && {
    border-bottom: 0.25rem solid transparent;
  }

  ${({ $active }) =>
    $active &&
    css`
      color: ${themeColor('heading')};

      && {
        border-bottom-color: ${themeColor('secondary')};
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
      }

      svg {
        path[fill] {
          fill: ${themeColor('heading')};
        }

        path[stroke] {
          stroke: ${themeColor('heading')};
        }
      }
    `}
`;
